// Inertia wheel-scrolling via Lenis - the same technique the luxury
// hospitality sites (Aman & co.) use for their "glide" feel.
// Touch devices keep native scrolling; reduced-motion users are skipped.
import Lenis from 'lenis';

let lenis = null;

export function initSmoothScroll() {
  if (lenis) return;
  if (typeof window === 'undefined') return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  // Pointer-fine check: skip phones/tablets, where native scroll is best
  if (!window.matchMedia('(pointer: fine)').matches) return;

  lenis = new Lenis({
    autoRaf: true,
    duration: 1.15,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    smoothWheel: true,
    syncTouch: false,
  });

  // Lenis animates the scroll itself; CSS smooth-behavior on top of it
  // would double-animate anchor jumps.
  document.documentElement.style.scrollBehavior = 'auto';

  // Let overlays (lightbox, booking window) freeze the page scroll
  window.__lenis = lenis;
}

export function stopSmoothScroll() {
  if (lenis) lenis.stop();
}

export function startSmoothScroll() {
  if (lenis) lenis.start();
}
